<template>
  <section>
    <!-- @close="togglePaymentModal"
      @submit="togglePaymentModal" -->
    <Modal :title="'Send a Tip'" v-model="paymentModal">
      <div class="mb-4">
        <div v-show="isNewCard">
          <section v-show="!isUserCard">
            <div class="flex pt-6 pb-5">
              <input v-if="userCardList && userCardList.length" type="radio" checked class="w-5 h-5 radio-green" />
              <p class="font-semibold text-base leading-5 tracking-tight" :class="userCardList && userCardList.length ? 'ml-3' : ''">
                Pay with card
              </p>
            </div>
            <p class="font-normal text-sm leading-5 text-gray-slate">
              {{ userCardList && userCardList.length == 0 ? "No card added" : "Select card:" }}
            </p>
            <div v-for="card in userCardList" :key="card.id">
              <div class="flex my-4" v-if="card.payment_method_id">
                <input
                  type="radio"
                  name="radio"
                  class="w-5 h-5 radio-green"
                  @click="onclickPaymentMethodId(card.payment_method_id)"
                />
                <p
                  class="font-noraml text-sm leading-5 ml-3 text-gray-slate capitalize"
                >
                  {{ card.brand || "CARD" }} {{ card.card_number }}
                </p>
              </div>
            </div>
            <button
              class="font-medium tex-sm leading-5 text-green-light mt-4 focus:outline-none"
              @click="onclickInitialize"
            >
              +Add new card
            </button>
          </section>
          <section v-show="isUserCard">
            <div class="flex pt-6 pb-5">
              <input
                type="radio"
                v-if="userCardList && userCardList.length"
                checked
                class="w-5 h-5 radio-gray cursor-pointer"
                @click="onclickToggleNewCard"
              />
              <p class="font-semibold text-base leading-5 tracking-tight" :class="userCardList && userCardList.length ? 'ml-3' : ''">
                Pay with card
              </p>
            </div>
            <p class="font-medium text-sm leading-5 mb-4">Card Details</p>

            <!-- Display a payment form -->
            <form class="mb-4" v-show="clientSecret">
              <div class="mb-4 text-gray-700">
                <input
                  class="w-full h-10 px-3 text-base placeholder-gray-900 ring-2 ring-gray-100 rounded-sm focus:outline-none shadow-md"
                  type="text"
                  placeholder="Name on card"
                  v-model="$v.nameOnCard.$model"
                  :class="{ 'ring-red-700': $v.nameOnCard.$error }"
                />
                <div v-if="$v.nameOnCard.$error">
                  <span
                    class="text-sm font-semibold text-red-600"
                    v-if="!$v.nameOnCard.required"
                  >
                    Your name on card is incomplete.
                  </span>
                </div>
              </div>
              <!-- <div id="payment-element"> -->
              <!--Stripe.js injects the Payment Element-->
              <!-- </div> -->
              <div class="mb-4 text-gray-700">
                <div
                  class="w-full h-10 px-3 text-base placeholder-gray-900 ring-2 ring-gray-100 rounded-sm focus:outline-none shadow-md"
                  id="card-number"
                ></div>
              </div>
              <div class="mb-4 text-gray-700">
                <div
                  class="w-full h-10 px-3 text-base placeholder-gray-900 ring-2 ring-gray-100 rounded-sm focus:outline-none shadow-md"
                  id="card-expiry"
                ></div>
              </div>
              <div class="mb-4 text-gray-700">
                <div
                  class="w-full h-10 px-3 text-base placeholder-gray-900 ring-2 ring-gray-100 rounded-sm focus:outline-none shadow-md"
                  id="card-cvv"
                ></div>
              </div>
            </form>

            <div class="flex">
              <input
                type="checkbox"
                class="w-5 h-5 mr-2 focus:outline-none"
                checked
              />
              <p class="font-normal text-sm leading-5">
                Save this card for future purchases
              </p>
            </div>
          </section>
        </div>

        <form class="space-y-4 text-gray-700" v-show="!isNewCard">
          <div>
            <div class="flex py-2 rounded-t-lg bg-green-light">
              <img
                class="h-10 w-10 rounded-full mx-2"
                :src="getUser('details') && getUser('details').thumbnail_url"
                alt=""
                @error="defaultCircleImage"
              />
              <div class="ml-3">
                <p class="text-sm font-medium text-white capitalize">
                  {{ getUser() && getUser().name }}
                </p>
                <p class="text-sm text-white">${{ intToFloat(amount, 2) }}</p>
              </div>
            </div>

            <textarea
              class="w-full h-28 px-3 py-2 text-sm text-white placeholder-white border rounded-b-lg focus:outline-none"
              style="background: #2f2e2e"
              placeholder="Say something..."
              v-model="message"
            ></textarea>
          </div>

          <div
            class="flex justify-center items-center my-2 py-2 rounded-lg"
            style="background: #2f2e2e"
          >
            <button
              type="button"
              class="mx-2"
              :class="{
                'opacity-50': amount <= 2,
              }"
              @click="onclickAmount(amount - 1)"
              :disabled="amount <= 2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-6 h-6 text-green-light"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm3 10.5a.75.75 0 000-1.5H9a.75.75 0 000 1.5h6z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
            <button
              class="inline-flex items-center justify-center w-10 h-10 mx-4 text-indigo-100 transition-colors duration-150 rounded-lg focus:shadow-outline"
            >
              <span class="text-2xl font-bold"
                >${{ intToFloat(amount, 2) }}</span
              >
            </button>
            <button
              type="button"
              class="mx-2"
              @click="onclickAmount(amount + 1)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-6 h-6 text-green-light"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>

          <div class="grid grid-cols-5 gap-5 py-2">
            <button
              type="button"
              class="inline-flex items-center justify-center w-10 h-10 mr-0 text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
              :style="{ background: amount == 2 ? '#8dc73f' : '#2f2e2e' }"
              @click="onclickAmount(2)"
            >
              <span class="text-xs font-semibold">$2</span>
            </button>
            <button
              type="button"
              class="inline-flex items-center justify-center w-10 h-10 mr-0 text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
              :style="{ background: amount == 5 ? '#8dc73f' : '#2f2e2e' }"
              @click="onclickAmount(5)"
            >
              <span class="text-xs font-semibold">$5</span>
            </button>
            <button
              type="button"
              class="inline-flex items-center justify-center w-10 h-10 mr-0 text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
              :style="{ background: amount == 10 ? '#8dc73f' : '#2f2e2e' }"
              @click="onclickAmount(10)"
            >
              <span class="text-xs font-semibold">$10</span>
            </button>
            <button
              type="button"
              class="inline-flex items-center justify-center w-10 h-10 mr-0 text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
              :style="{ background: amount == 20 ? '#8dc73f' : '#2f2e2e' }"
              @click="onclickAmount(20)"
            >
              <span class="text-xs font-semibold">$20</span>
            </button>
            <button
              type="button"
              class="inline-flex items-center justify-center w-10 h-10 mr-0 text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
              :style="{ background: amount == 50 ? '#8dc73f' : '#2f2e2e' }"
              @click="onclickAmount(50)"
            >
              <span class="text-xs font-semibold">$50</span>
            </button>
          </div>
        </form>
      </div>
      <section class="" v-if="isNewCard">
        <p class="font-semibold text-xl leading-8 tracking-tight">
          Payment Summary
        </p>
        <div class="flex justify-between pt-2">
          <p class="text-sm font-medium leading-4 text-gray-slate">
            Tip Amount
          </p>
          <p class="text-sm font-medium leading-4">
            ${{ intToFloat(this.amount, 2) }}
          </p>
        </div>
        <div class="flex justify-between pt-2">
          <!-- <p class="text-sm font-medium leading-4 text-gray-slate">
            Service Fee
          </p> -->
          <button
            class="flex items-center text-gray-slate transition-colors duration-150 bg-white rounded focus:outline-none hover:bg-white"
            title="This fee helps support the Fitclass platform and covers a broad range of operating costs and customer support."
          >
            <span class="text-sm">Service Fee</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
          </button>
          <p class="text-sm font-medium leading-4">
            ${{ this.platformServiceFee }}
          </p>
        </div>
        <div class="flex justify-between pt-3">
          <p class="text-base font-bold leading-5">Total</p>
          <p class="text-base font-bold leading-6">
            ${{ intToFloat(this.amount + Number(this.platformServiceFee), 2) }}
          </p>
        </div>
        <div class="my-4" v-show="isUserCard">
          <button
            class="w-full h-12 px-6 text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
            @click="onclickSubmit"
            :disabled="isProcessing"
          >
            {{ isProcessing ? "Paying..." : "Pay" }}
          </button>
        </div>
        <div class="my-4" v-show="!isUserCard">
          <button
            class="w-full h-12 px-6 text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
            @click="onclickPaywithCard"
            :disabled="isProcessing"
          >
            {{ isProcessing ? "Paying..." : "Pay with card" }}
          </button>
        </div>
      </section>
      <button
        class="w-full h-12 px-6 text-white transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
        @click="initialize('tipButton')"
        :disabled="sendTipBtnText === 'Initiating'"
        :class="sendTipBtnText === 'Initiating' ? 'cursor-not-allowed' : ''"
        v-show="!isNewCard"
      >
        {{ sendTipBtnText }}
      </button>
    </Modal>

    <!-- footer-button__wrapper -->
    <div class="absolute right-0 bottom-0 mr-28" v-if="!callerComp">
      <button
        type="button"
        class="footer-button-base__button ax-outline send-video-container__btn"
        arialabel="start sending my video"
        :disabled="isTipButtonDisabled"
        @click="togglePaymentModal"
      >
        <div class="footer-button-base__img-layer text-green-light">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <span class="footer-button-base__button-label text-green-light"
          >Tip Trainer</span
        >
      </button>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import store from "@/store";
import { required } from "vuelidate/lib/validators";
import { Modal } from "@/components/t-components";

export default {
  name: "TipPaymentModal",
  props: {
    details: {
      type: Object,
    },
    callerComp: {
      type: String
    },
    tipModalHandler: {
      type: Function
    }
  },
  components: {
    Modal,
  },
  data() {
    return {
      paymentModal: true,
      stripe: Stripe(window.config.VUE_APP_STRIPE_CLIENT_ID, {
        stripeAccount: this.details && this.details.trainer_account_id,
      }),
      stripe1: Stripe(window.config.VUE_APP_STRIPE_CLIENT_ID),
      // The items the customer wants to buy
      elements: {},
      nameOnCard: null,
      amount: 5,
      message: null,
      paymentMethodId: null,
      platformServiceFee: 0,
      clientSecret: null,
      isProcessing: false,
      isNewCard: false,
      isUserCard: false,
      userCardList: [],
      cardNumberElement: null,
      cardExpiryElement: null,
      cardCvcElement: null,
      isTipButtonDisabled: false,
      sendTipBtnText: 'Send Tip'
    };
  },
  validations: {
    nameOnCard: {
      required,
    },
  },
  methods: {
    async togglePaymentModal() {
      this.isNewCard = false;
      this.isUserCard = false;
      this.paymentModal = !this.paymentModal;
    },

    async onclickInitialize() {
      // const appearance = {
      //   theme: "flat",
      //   labels: "floating",
      //   variables: {
      //     fontWeightNormal: "500",
      //     borderRadius: "2px",
      //     colorBackground: "white",
      //     colorPrimary: "#DF1B41",
      //     colorPrimaryText: "white",
      //     spacingGridRow: "15px",
      //   },
      //   rules: {
      //     ".Label": {
      //       marginBottom: "3px",
      //     },
      //     ".Tab, .Input, .Block": {
      //       boxShadow: "0px 3px 10px rgba(18, 42, 66, 0.08)",
      //       padding: "6px",
      //     },
      //   },
      // };

      var style = {
        base: {
          iconColor: "#666EE8",
          color: "#31325F",
          lineHeight: "40px",
          fontWeight: 300,
          fontFamily: "inherit",
          fontSize: "15px",
          "::placeholder": {
            color: "#000",
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
          },
        },
      };
      // this.elements = await this.stripe.elements({
      //   clientSecret: this.clientSecret,
      //   appearance,
      // });
      // const paymentElement = this.elements.create("payment");
      // paymentElement.mount("#payment-element");
      // this.onclickNewCard();
      this.elements = await this.stripe1.elements();
      this.cardNumberElement = this.elements.create("cardNumber", {
        style: style,
        placeholder: "Card number",
      });
      this.cardNumberElement.mount("#card-number");

      this.cardExpiryElement = this.elements.create("cardExpiry", {
        style: style,
        placeholder: "MM/YY",
      });
      this.cardExpiryElement.mount("#card-expiry");

      this.cardCvcElement = this.elements.create("cardCvc", {
        style: style,
        placeholder: "CVC",
      });
      this.cardCvcElement.mount("#card-cvv");
      this.isUserCard = true;
    },

    onclickNewCard() {
      this.isNewCard = !this.isNewCard;
    },

    onclickToggleNewCard() {
      this.isUserCard = !this.isUserCard;
    },

    async initialize(caller) {
      var details = this.getUser("details");
      let payload = {
        amount: this.amount,
        message: this.message,
        paymentMethodId: this.paymentMethodId,
        line1: details && details.street_address,
        postal_code: details && details.postal_code,
        city: details && details.city,
        state: details && details.state,
        country: details && details.country,
      };
      if (!this.callerComp) {
        payload.batch_id = this.batchId;
      } else if ( this.callerComp && this.callerComp === 'UserTrainer') {
        payload.trainerId = this.details && this.details.user_id
      }
      this.sendTipBtnText = 'Initiating'
      await axios
        .post(`user/${this.callerComp && this.callerComp === 'UserTrainer' ? 'initiate-profile-tip-payment' : 'initiate-tip-payment'}`, payload)
        .then((res) => {
          const data = res && res.data && res.data.data;
          caller && caller.length ? this.onclickNewCard() : ''
          this.clientSecret = data && data.clientSecret;
          this.paymentMethodId = data && data.paymentMethodId;
          this.platformServiceFee = data && data.serviceFee || 0;
          this.sendTipBtnText = 'Send Tip'
          this.clientSecret ? this.isTipButtonDisabled = false : ''
        })
        .catch((e) => {
          console.log(e);
          this.isProcessing = false;
          store.commit("setIsLoading", false);
          this.callerComp && this.callerComp === 'UserTrainer' ? this.tipModalHandler() : ''
          // this.paymentModal = true
          this.sendTipBtnText = 'Send Tip'
          this.isTipButtonDisabled = true
        });
    },

    // Fetches a payment intent and captures the client secret
    async onclickSubmit(e) {
      e.preventDefault();
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        this.isProcessing = true;
        store.commit("setIsLoading", true);
        let token = null;
        let paymentMethod = null;
        await this.stripe1
          .createToken(this.cardNumberElement)
          .then((result) => {
            if (result.error) {
              alert(result.error.message);
              this.isProcessing = false;
              store.commit("setIsLoading", false);
            } else {
              token = result.token.id;
            }
          })
          .catch((e) => {
            console.log(e);
            this.isProcessing = false;
            store.commit("setIsLoading", false);
          });

        if (token == null) {
          this.isProcessing = false;
          store.commit("setIsLoading", false);
          return false;
        }

        await axios
          .post(`user/setup-card`, {
            tokenId: token,
            name: this.nameOnCard,
          })
          .then((res) => {
            paymentMethod = res.data.data.paymentMethodId;
          })
          .catch((e) => {
            console.log(e);
            this.isProcessing = false;
            store.commit("setIsLoading", false);
          });

        this.paymentMethodId = paymentMethod;

        await this.initialize();

        await this.stripe
          .confirmCardPayment(this.clientSecret, {
            payment_method: this.paymentMethodId,
          })
          .then((result) => {
            if (result.error) {
              // Show error message using (result.error.message);
              // enable payment button
              alert(result.error.message);
              this.isProcessing = false;
              store.commit("setIsLoading", false);
            } else {
              let data = {
                amount: this.amount,
                nameOnCard: this.nameOnCard,
                message: this.message,
                paymentIntentid: result.paymentIntent.id,
                paymentStatus: "succeeded",
              };
              if (!this.callerComp) {
                data.batchId = this.batchId;
              } else if ( this.callerComp && this.callerComp === 'UserTrainer') {
                data.trainerId = this.details && this.details.user_id
              }
              switch (result.paymentIntent.status) {
                case "succeeded":
                  // Create http request to save result.paymentIntent.id in to database
                  axios
                    .post(`user/${this.callerComp && this.callerComp === 'UserTrainer' ? 'complete-profile-tip-payment' : 'complete-tip-payment'}`, data)
                    .then(() => {
                      this.togglePaymentModal();
                      store.commit(
                        "setIsSuccess",
                        "Payment completed Successfully"
                      );
                    })
                    .catch((e) => {
                      console.log(e);
                      this.isProcessing = false;
                      store.commit("setIsLoading", false);
                    });
                  break;
                case "processing":
                  // show Your Payment is Processing success message to user
                  console.log("Processing..");
                  break;
                case "requires_payment_method":
                  // Your payment was not successful, please try again.
                  alert("Please try again");
                  break;
                default:
                  // Something went wrong error message
                  alert("Something went wrong");
                  break;
              }
            }
          })
          .catch((e) => {
            console.log(e);
            this.isProcessing = false;
            store.commit("setIsLoading", false);
          });
        this.isProcessing = false;
        store.commit("setIsLoading", false);
      }
    },

    async onclickPaywithCard(e) {
      e.preventDefault();

      if (!this.clientSecret) {
        alert("Please choose payment method");
        return;
      } else if (!this.paymentMethodId) {
        this.userCardList && this.userCardList.length ? alert("Please choose a card") : alert("Please Add a card")
        return;
      }
      this.isProcessing = true;
      store.commit("setIsLoading", true);
      await this.stripe.confirmCardPayment(this.clientSecret, {
        payment_method: this.paymentMethodId,
      })
      .then((result) => {
        if (result.error) {
          alert(result.error.message);
          this.isProcessing = false;
          store.commit("setIsLoading", false);
        } else {
          let data = {
            amount: this.amount,
            message: this.message,
            paymentIntentid: result.paymentIntent.id,
            paymentStatus: "succeeded",
          };
          if (!this.callerComp) {
            data.batchId = this.batchId;
          } else if ( this.callerComp && this.callerComp === 'UserTrainer') {
            data.trainerId = this.details && this.details.user_id
          }
          switch (result.paymentIntent.status) {
            case "succeeded":
              axios
                .post(`user/${this.callerComp && this.callerComp === 'UserTrainer' ? 'complete-profile-tip-payment' : 'complete-tip-payment'}`, data)
                .then(() => {
                  this.togglePaymentModal();
                  store.commit(
                    "setIsSuccess",
                    "Payment completed Successfully"
                  );
                })
                .catch((e) => {
                  console.log(e);
                  this.isProcessing = false;
                  store.commit("setIsLoading", false);
                });
              break;
            case "processing":
              console.log("Processing..");
              break;
            case "requires_payment_method":
              alert("Please try again");
              break;
            default:
              alert("Something went wrong");
              break;
          }
        }
      })
      .catch((e) => {
        console.log(e);
        this.isProcessing = false;
        store.commit("setIsLoading", false);
      });
      this.isProcessing = false;
      store.commit("setIsLoading", false);
    },

    async onclickPaymentMethodId(id) {
      this.paymentMethodId = id;
      await this.initialize();
      this.isUserCard = false;
    },

    onclickAmount(val) {
      this.amount = val;
    },

    async getUserCardList() {
      const res = await axios.get(`user/card-list`);
      this.userCardList = res && res.data && res.data.data;
    },
  },
  async created() {
    // get saved cards of user
    await this.getUserCardList();
  },
  async mounted() {
    // this.callerComp && this.callerComp === 'UserTrainer' ? await this.initialize() : ''
  },
  watch: {
    paymentModal () {
      !this.paymentModal && this.callerComp && this.callerComp === 'UserTrainer' ? this.tipModalHandler() : ''
    }
  }
};
</script>

<style scoped>
.radio-gray:checked {
  /* The native appearance is hidden */
  appearance: none;
  -webkit-appearance: none;
  /* For a circular appearance we need a border-radius. */
  border-radius: 50%;
  /* The background will be the radio dot's color. */
  background: darkgray;
  /* The border will be the spacing between the dot and the outer circle */
  border: 3px solid #fff;
  /* And by creating a box-shadow with no offset and no blur, we have an outer circle */
  box-shadow: 0 0 0 1px darkgray;
}
.radio-green:checked {
  appearance: none;
  -webkit-appearance: none;
  border-radius: 50%;
  background: #99c355;
  border: 3px solid #fff;
  box-shadow: 0 0 0 1px #99c355;
}
</style>